import { Link, useLocation } from '@remix-run/react';
import Sprite from '../../sprites/sprite';
import { FACEBOOK, INSTAGRAM, TWITTER, YOUTUBE } from '../../constants/socials';
import React from 'react';
import { useMessages } from '../../i18n/useMessages';
import { isInquiryModeEnabled } from '../../state/inquiry-modal';

interface BannerProps {
  onOpenInquiry: VoidFunction;
}

export const AVOID_LIST = [
  '/packages/reservation',
  '/packages/reservation/complete-payment',
  '/packages/reservation/complete-payment-paypal',
];

export const Banner: React.FC<BannerProps> = ({ onOpenInquiry }) => {
  const location = useLocation();
  const getMessage = useMessages();
  const inquireNow = getMessage('camp67-banner.inquire-now');
  const bookNow = getMessage('camp67-banner.book-now');

  if (AVOID_LIST.includes(location.pathname)) {
    return null;
  }

  const isInquiryExperimentEnabled = isInquiryModeEnabled;

  return (
    <div
      id="camp67-banner"
      className="w-full z-30 bg-white flex flex-row items-center fixed shadow-md shadow-black/5 top-0 left-0 py-4 px-6 sm:px-2 md:px-24 lg:px-56"
    >
      <ul className="w-full flex flex-row flex-wrap items-center">
        <span className="flex flex-row flex-wrap items-center whitespace-nowrap gap-1 text-sm">
          <span className="flex flex-row items-center gap-1">
            <Sprite name="phone" width="16" height="16" className="w-3.5 h-3.5 fill-current" />
            <span>/</span>
            <Sprite name="whatsapp" width="24" height="24" className="w-4 h-4" />
            <span>+91 8485835675</span>
          </span>
        </span>
      </ul>
      <div className="flex flex-row h-full items-center gap-6">
        <div className="flex flex-row items-center gap-1">
          {isInquiryExperimentEnabled ? (
            <button
              onClick={onOpenInquiry}
              className="bg-red-200 hover:bg-red-300 text-white transition-all px-4 py-1.5 rounded-lg whitespace-nowrap text-sm font-semibold shadow-sm"
            >
              {inquireNow}
            </button>
          ) : (
            <>
              <button
                onClick={onOpenInquiry}
                className="hidden xs:block bg-gray-100 hover:bg-gray-200 transition px-3 py-1.5 rounded-lg whitespace-nowrap text-sm"
              >
                {inquireNow}
              </button>
              <Link to="/packages/reservation" prefetch="intent">
                <button className="hidden xs:block bg-red-200 hover:bg-red-300 text-white transition-all px-4 py-1.5 rounded-lg whitespace-nowrap text-sm font-semibold shadow-sm">
                  {bookNow}
                </button>
              </Link>
            </>
          )}
        </div>
        <div className="hidden sm:block w-0.5 h-9 border-r border-r-black border-dotted" />
        <ul className="hidden md:flex flex-row items-center">
          <a href={FACEBOOK} target="_blank" rel="noreferrer">
            <li className="cursor-pointer hover:opacity-75 transition">
              <Sprite
                name="facebook"
                width="64"
                height="64"
                fill="#D4D400"
                className="min-w-7 w-7 min-h-7 h-7"
              />
            </li>
          </a>
          <a href={INSTAGRAM} target="_blank" rel="noreferrer">
            <li className="cursor-pointer hover:opacity-75 transition">
              <img
                src="/instagram.png"
                alt="Instagram logo"
                className="min-w-7 min-h-7"
              />
            </li>
          </a>
          <a href={TWITTER} target="_blank" rel="noreferrer">
            <li className="cursor-pointer hover:opacity-75 transition">
              <Sprite
                name="twitter"
                width="64"
                height="64"
                fill="#D4D400"
                className="min-w-7 w-7 min-h-7 h-7"
              />
            </li>
          </a>
          <a href={YOUTUBE} target="_blank" rel="noreferrer">
            <li className="cursor-pointer hover:opacity-75 transition">
              <Sprite
                name="youtube"
                width="64"
                height="45"
                fill="#D4D400"
                className="min-w-7 w-7 min-h-7 h-7"
              />
            </li>
          </a>
        </ul>
      </div>
    </div>
  );
};
